module.exports = __webpack_public_path__ + "img/logger.8e95b504.png";